export { default } from './glossaryReducer';
